import React, {useState} from 'react';
import BaseButton from "./BaseButton";
import Loader from "./Loader";
import RideDetailsLine from "./RideDetailsLine";
import PageLabel from "./PageLabel";
import chevronUp from '../assets/fi_chevron-up.svg';
import chevronDown from '../assets/fi_chevron-down.svg';
import callIcon from '../assets/fi_phone.svg';
import xIcon from '../assets/fi_x-circle.svg';
import ConfirmCancellation from "./Modal/ConfirmCancellation";
import VoipCallModal from "./Modal/VoipCallModal";
import backendApi from "../services/backendApi";

function RideInProgress({ setRideInProgress, order }) {

    const [loading, setLoading] = useState(false);
    const [tariffsVisible, setTariffsVisible] = useState(false);
    const [cancellationModalOpen, setCancellationModalOpen] = useState(false);
    const [callModalOpen, setCallModalOpen] = useState(false);
    const [voipData, setVoipData] = useState(null);
    const [cancellationError, setCancellationError] = useState(null);

    const statusLabels = {
        ARRIVES: "Automobilis atvyksta",
        ARRIVED: "Vairuotojas atvyko ir Jūsų laukia",
        ONGOING: "Keleivis automobilyje",
        COMPLETED: "Kelionė baigta",
        CANCELED: "Užsakymas atšauktas",
    };

    const cancelOrder = async (reason) => {
        setLoading(true);
        setCancellationError(null);

        try {
            const response = await backendApi.post('/api/cancel-order', {orderId: order.id, reason: reason}, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.data.result != true) {
                setCancellationError("Nepavyko atšaukti kelionės. Bandykite dar kartą.");
            } else {
                setCancellationModalOpen(false);
                setRideInProgress(false);

            }
        } catch (error) {
            setCancellationError("Nepavyko atšaukti kelionės. Bandykite dar kartą.");
        } finally {
            setLoading(false);
        }
    };

    const handleCallClick = async () => {
        console.log('Fetching VoIP credentials...');
        setLoading(true);

        try {
            const response = await backendApi.get('/api/voip-login');

            setVoipData(response.data);
            setCallModalOpen(true);
        } catch (error) {
            console.error('Failed to load VoIP login data:', error);
            alert('Nepavyko gauti VoIP duomenų');
        } finally {
            setLoading(false);
        }
    };


    if (loading) return <Loader />;
    if (cancellationModalOpen) return <ConfirmCancellation handleCancellation={cancelOrder} setCancellationModalOpen={setCancellationModalOpen} externalError={cancellationError} />;
    if (callModalOpen) return <VoipCallModal data={voipData} orderId={order.id} onClose={() => setCallModalOpen(false)} phoneToCall={order.driver.phone.replace('+', '')} />

    return (
        <>
            <PageLabel text={statusLabels[order.status]} />
            <div className="rideInProgress pageContent">
                <h3>{statusLabels[order.status]}</h3>

                {/* Car Details */}
                <div className="rideInProgress__content rideInProgress__arriving">
                    <div className="rideInProgress__carDetails rideDetails__section">
                        <img
                            src={order?.car?.picture}
                            alt="Automobilis"
                            className="car-image"
                        />
                        <div className="car-info">
                            <span>{order?.car?.name}</span>
                            <span>{order?.car?.licencePlate}</span>

                            {order?.status === "ARRIVES" && (
                                <div className="rideInProgress__timeWhen">
                                    <span>{order?.timeWhen} min</span>
                                </div>
                            )}

                            {order?.status === "ARRIVED" && order?.waitTime > 0 && (
                                <div className="rideInProgress__timeWhen">
                                    <span>{order?.waitTime} min</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Driver Details */}
                    <div className="rideInProgress__driver rideDetails__section">
                        <div className="rideDetails__driver">
                            <RideDetailsLine text="Vairuotojas" value={order?.driver?.fullName} />
                            {order?.driver?.licence && (
                                <RideDetailsLine text="Leidimo nr." value={order.driver.licence} />
                            )}
                        </div>

                        {order?.paymentMethod === "cash" && (
                            <div className="rideDetails__driver">
                                <RideDetailsLine
                                    text="Preliminari kaina"
                                    value={`${order?.price} €`}
                                />
                            </div>
                        )}
                    </div>

                    {/* Tariffs */}
                    <div className="rideDetails__tariffs rideDetails__section">
                        <div
                            id="showHideTariffs"
                            className="accordion mapCollapse"
                            onClick={() => setTariffsVisible(!tariffsVisible)}
                        >
                            <div className="accordion__header js-header">
                                <p className="accordion__itemTitle">Tarifai</p>
                                <img
                                    className="accordion__icon js-iconDown accordion__icon--visible"
                                    src={tariffsVisible ? chevronUp : chevronDown}
                                    alt=""
                                    loading="lazy"
                                />
                            </div>
                        </div>

                        <div className={tariffsVisible ? "accordion__content--visible" : "accordion__content"}>
                            <RideDetailsLine text="Įsėdimas" value={`${order?.tariffs?.startPrice} €`} />
                            <RideDetailsLine text="Miesto tarifas" value={`${order?.tariffs?.cityKmPrice} €/km`} />
                            <RideDetailsLine text="Užmiesčio tarifas" value={`${order?.tariffs?.districtKmPrice} €/km`} />
                            <RideDetailsLine text="Prastova" value={`${order?.tariffs?.traffic} €/10min`} />
                            <RideDetailsLine text="Minimalus pravažiavimas" value={`${order?.tariffs?.minPrice} €`} />
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="rideInProgress__buttons">
                    <BaseButton
                        text="Skambinti"
                        handleOnClick={handleCallClick}
                        className="baseButton--secondary"
                        icon={callIcon}
                    />
                    {(order?.status === "ARRIVES" || order?.status === "ARRIVED") && (
                        <BaseButton
                            text="Atšaukti"
                            handleOnClick={() => {
                                setCancellationModalOpen((prev) => !prev);
                                setCancellationError(null);
                            }}
                            className="baseButton--secondary-danger"
                            icon={xIcon}
                        />
                    )}
                </div>
            </div>
        </>
    );

}

export default RideInProgress;